let Datalayer = class Datalayer {
    get property() {
        return this._property;
    }
    set property(value) {
        this._property = value;
    }
    get event() {
        return this._event;
    }
    set event(value) {
        this._event = value;
    }
    constructor(event, property){
        this._event = event;
        this._property = property;
    }
};

export { Datalayer as default };
